import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { type PayoutsAdminViewModel } from '@/features/payouts/admin/PayoutsAdminViewModel'
import { PayoutReviewContainer } from '@/features/payouts/admin/review/components/PayoutReview/PayoutReviewContainer'

export default observer(function PayoutsAdminReviewContainer() {
  const vm = useOutletContext<PayoutsAdminViewModel>()
  return <PayoutReviewContainer vm={vm.reviewVm} />
})
